import {TextInput, FormControl} from '@primer/react'
import {Dialog} from '@primer/react/experimental'
import {useState, useRef, useCallback, type FormEvent} from 'react'

export interface CreateTagDialogProps {
  onDismiss: () => void
  onCreate: (tagName: string) => void
  initialTagName?: string
}

export function CreateTagDialog({onDismiss, onCreate, initialTagName}: CreateTagDialogProps) {
  const [tagName, setTagName] = useState(initialTagName)
  const inputRef = useRef<HTMLInputElement>(null)
  const trimmedTagName = tagName?.trim()

  const handleCreate = useCallback(() => {
    if (trimmedTagName) {
      onCreate(trimmedTagName)
      onDismiss()
    }
  }, [trimmedTagName, onCreate, onDismiss])

  const handleSubmit = useCallback(
    (e: FormEvent) => {
      e.preventDefault()
      handleCreate()
    },
    [handleCreate],
  )

  return (
    <Dialog
      onClose={onDismiss}
      title="Create new tag"
      width="medium"
      initialFocusRef={inputRef}
      footerButtons={[
        {buttonType: 'default', content: 'Cancel', onClick: onDismiss},
        {buttonType: 'primary', content: 'Create', onClick: handleCreate, disabled: !trimmedTagName, type: 'submit'},
      ]}
    >
      <form onSubmit={handleSubmit}>
        <FormControl required>
          <FormControl.Label>Tag</FormControl.Label>
          <TextInput
            ref={inputRef}
            value={tagName}
            onChange={e => setTagName(e.target.value)}
            aria-label="Tag name"
            block
          />
        </FormControl>
      </form>
    </Dialog>
  )
}

try{ CreateTagDialog.displayName ||= 'CreateTagDialog' } catch {}